!(function (t, e) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
    ? define([], e)
    : 'object' == typeof exports
    ? (exports.Accordion = e())
    : (t.Accordion = e());
})(self, () =>
  (() => {
    'use strict';
    var t = {
        d: (e, s) => {
          for (var i in s) t.o(s, i) && !t.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: s[i] });
        },
        o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
        r: (t) => {
          'undefined' != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
            Object.defineProperty(t, '__esModule', { value: !0 });
        },
      },
      e = {};
    t.r(e), t.d(e, { default: () => h });
    const s = (t) => t.classList.remove('is-active'),
      i = (t, e = {}, s = '') => {
        const i = new CustomEvent(`Panel.${s}`, { bubbles: !1, cancelable: !0, detail: e });
        return t.dispatchEvent(i);
      },
      n = 'aria-expanded';
    class o {
      constructor(t) {
        (this.$body = null),
          (this.$button = null),
          (this.$inner = null),
          (this.isDeselect = !1),
          (this.isOpen = !1),
          (this.height = 0),
          (this.handleClick = () =>
            (!1 !== this.isDeselect || !0 !== this.isOpen) &&
            (!0 === this.isOpen
              ? (i(this.el, { current: this.el }, 'close'), this.close())
              : !1 !== this.isOpen || (i(this.el, { current: this.el }, 'open'), this.open()))),
          (this.resize = () => {
            var t;
            (this.height = (null === (t = this.$inner) || void 0 === t ? void 0 : t.offsetHeight) || 0),
              this.isOpen && this.$body.style.setProperty('max-height', `${this.height}px`);
          }),
          (this.el = t);
      }
      init() {
        var t;
        this.$button = this.el.querySelector('.js-accordion-header');
        const e =
          (null === (t = this.$button.getAttribute('aria-controls')) || void 0 === t
            ? void 0
            : t.trim().split(' ')[0]) || '';
        (this.$body = document.getElementById(e)),
          (this.$inner = this.$body.querySelector('.js-accordion-inner')),
          (this.isDeselect = JSON.parse(this.el.getAttribute('data-accordion-deselect'))),
          (this.isOpen = JSON.parse(this.el.getAttribute('data-accordion-open'))),
          this.$body.style.setProperty('max-height', this.height.toString()),
          this.$body.style.setProperty('overflow', 'hidden'),
          this.$body.setAttribute('aria-labelledby', `${this.$button.id}`),
          this.resize(),
          this.initEvents(),
          !0 === this.isOpen && this.open();
      }
      initEvents() {
        this.$button.addEventListener('click', this.handleClick), window.addEventListener('resize', this.resize);
      }
      close() {
        this.el.setAttribute('data-accordion-open', 'false'),
          this.$button.setAttribute(n, 'false'),
          this.$body.style.setProperty('max-height', '0'),
          s(this.el),
          (this.isOpen = !1);
      }
      open() {
        this.el.setAttribute('data-accordion-open', 'true'),
          this.$button.setAttribute(n, 'true'),
          this.$body.style.setProperty('max-height', `${this.height}px`),
          this.el.classList.add('is-active'),
          (this.isOpen = !0);
      }
      destroy() {
        this.$button.removeEventListener('click', this.handleClick),
          window.removeEventListener('resize', this.resize),
          this.$body.style.removeProperty('max-height'),
          this.$body.style.removeProperty('overflow'),
          s(this.el);
      }
    }
    const r = { multiselectable: !1 };
    class h {
      constructor(t, e = {}) {
        (this.accordions = []),
          (this.panels = []),
          (this.current = 0),
          (this.handleHashchange = () => {
            this.panels.forEach(
              (t, e) =>
                !t.$body ||
                `#${t.$body.id}` !== document.location.hash.replace(/^#\//, '') ||
                ((this.current = e), this.closeAll(), t.open())
            );
          }),
          (this.handleKeydown = (t) => {
            const { target: e, key: s, code: i } = t,
              n = () => {
                var s;
                e.classList.contains('js-accordion-header') &&
                  ((this.current = this.current + 1 > this.panels.length - 1 ? 0 : this.current + 1),
                  null === (s = this.panels[this.current].$button) || void 0 === s || s.focus(),
                  t.preventDefault());
              },
              o = () => {
                var s;
                e.classList.contains('js-accordion-header') &&
                  ((this.current = 0 > this.current - 1 ? this.panels.length - 1 : this.current - 1),
                  null === (s = this.panels[this.current].$button) || void 0 === s || s.focus(),
                  t.preventDefault());
              },
              r = {
                ArrowUp: o,
                ArrowRight: n,
                ArrowDown: n,
                ArrowLeft: o,
                Home: () => {
                  var e;
                  null === (e = this.panels[0].$button) || void 0 === e || e.focus(), t.preventDefault();
                },
                End: () => {
                  var e;
                  null === (e = this.panels[this.panels.length - 1].$button) || void 0 === e || e.focus(),
                    t.preventDefault();
                },
                default: () => !1,
              };
            return (r[s || i] || r.default)();
          }),
          (this.closeAll = () => this.panels.forEach((t) => t.close())),
          (this.el = t),
          (this.options = { ...r, ...e });
      }
      init() {
        return (
          null !== this.el &&
          void 0 !== this.el &&
          ((this.accordions = [...this.el.children].filter((t) => t.classList.contains('js-accordion-panel'))),
          this.accordions.forEach((t, e) => {
            const s = new o(t);
            return (
              s.init(),
              this.panels.push(s),
              t.addEventListener('Panel.open', () => {
                (this.current = e), this.options.multiselectable || this.closeAll();
              }),
              !0
            );
          }),
          this.initEvents(),
          this.handleHashchange(),
          !0)
        );
      }
      initEvents() {
        window.addEventListener('hashchange', this.handleHashchange),
          this.el.addEventListener('keydown', this.handleKeydown);
      }
      destroyAll() {
        return (
          this.panels.forEach((t) => t.destroy()),
          (this.panels = []),
          window.removeEventListener('hashchange', this.handleHashchange, !1),
          this.el.removeEventListener('keydown', this.handleKeydown),
          !0
        );
      }
    }
    return e;
  })()
);
